import { combineReducers } from '@reduxjs/toolkit';
import paymentsReducer from './payments';
import modalsReducer from './modals';
import invoiceDataReducer from './invoice';

const rootReducer = combineReducers({
  paymentsReducer,
  modalsReducer,
  invoiceDataReducer,
});

export default rootReducer;
